import React, { useState } from "react";
import { Input } from "@swordsweeper/ssi-ui-component-library";
import * as Yup from "yup";
import classnames from "classnames";
import styles from "./ClinicSelectionForm.module.scss";

export const schema = Yup.object().shape({
  clinicId: Yup.string().required(),
});

export default function ClinicSelectionForm({
  formData,
  onChange,
  clinicUsers = [],
}) {
  const [search, setSearch] = useState<string | null>(null);

  let filteredClinicUsers = [...clinicUsers];
  if (!!search) {
    filteredClinicUsers = filteredClinicUsers.filter((clinicUser) =>
      clinicUser.clinic.name.toLowerCase().includes(search.toLowerCase()),
    );
  }

  return (
    <>
      <Input
        defaultValue=""
        onChange={setSearch}
        value={search}
        placeholder="Search"
        width="100%"
        icon={<i className="fa-light fa-magnifying-glass" />}
      />

      <div>
        {filteredClinicUsers.map(({ clinic }) => {
          const isSelected = formData.clinicId === clinic.id;
          return (
            <div
              key={`clinic-selection-row-${clinic.id}`}
              className={classnames("border-bottom", styles.selectableItem, {
                [styles.selected]: isSelected,
              })}
              onClick={
                isSelected
                  ? null
                  : () => onChange({ name: "clinicId", value: clinic.id })
              }
            >
              <div>{clinic.name}</div>
              <div className="text-sm font-weight-normal">
                {clinic.city}, {clinic.state}
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
}
